const getPropsFromWindow = function getPropsFromWindowObject(Component, domId) {
  if (Object.hasOwnProperty.call(Component, 'getComponentData')) {
    return Component.getComponentData();
  }
  return window.seMarketplace[domId];
};

export default getPropsFromWindow;
